/**
 * `departments` — Settings ▸ Org wire surface (ADR-0030).
 *
 * Procedures:
 *   - `list`    — the active org tree (tenanted)
 *   - `create`  — add an org unit          (permission: settings.manage)
 *   - `update`  — rename / re-parent / sort (permission: settings.manage)
 *   - `archive` — soft-delete a unit        (permission: settings.manage)
 */
import { z } from "zod";
import { uuid } from "../_common.js";

export const departmentView = z.object({
  id: uuid,
  name: z.string(),
  parentDepartmentId: uuid.nullable(),
  sort: z.number().int(),
});

export const listInput = z.object({});
export const listOutput = z.object({ departments: z.array(departmentView) });

export const createInput = z.object({
  name: z.string().trim().min(1).max(80),
  parentDepartmentId: uuid.nullable().optional(),
});
export const createOutput = departmentView;

export const updateInput = z.object({
  departmentId: uuid,
  name: z.string().trim().min(1).max(80).optional(),
  parentDepartmentId: uuid.nullable().optional(),
  sort: z.number().int().min(0).max(9999).optional(),
});
export const updateOutput = departmentView;

export const archiveInput = z.object({ departmentId: uuid });
export const archiveOutput = z.object({ departmentId: uuid, archivedAt: z.string() });
